import { BAvatar, BImg } from 'bootstrap-vue';

export default {
  props: {
    className: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    fullName: {
      type: String,
      default: null,
    },
    rounded: {
      type: String,
      default: 'circle',
    },
    size: {
      type: Number,
      default: 30,
    },
  },
  render(el) {
    if (typeof this.fullName === 'string' && this.fullName.trim().includes(' ')) {
      const [ firstName, lastName ] = this.fullName.split(' ');
      return el(BAvatar, {
        class: this.className,
        props: {
          rounded: this.rounded,
          size: this.size,
          text: `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`.toUpperCase(),
          variant: 'primary',
        },
      });
    } else if (this.user && this.user.profileImage && this.user.profileImage.fileLocation) {
      const { fileName, fileLocation } = this.user.profileImage;
      return el(BImg, {
        class: this.className || 'img-fit-cover',
        props: {
          alt: fileName,
          height: this.size,
          rounded: this.rounded,
          src: fileLocation,
          width: this.size,
        },
      });
    } else if (this.user && typeof this.user.firstName === 'string' && typeof this.user.lastName === 'string') {
      const { firstName, lastName } = this.user || {};
      return el(BAvatar, {
        class: this.className,
        props: {
          rounded: this.rounded,
          size: this.size,
          text: `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`.toUpperCase(),
          variant: 'primary',
        },
      });
    } else {
      return el(BAvatar, {
        class: this.className,
        props: {
          rounded: this.rounded,
          variant: 'primary',
        },
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/users/Avatar.js